export const styles = {
  notificationHeaderText: {
    color: "#84818a",
  },
  notifications: {
    flexWrap: "nowrap",
    overflowY: "auto",
    pr: "5px",
    maxHeight: "400px",
    minHeight: "150px",
    height: "calc(100vh - 150px)",
    position: "relative",
    justifyContent: "safe flex-start",
    alignItems: "safe center",
  },
  notificationBadge: {
    "& .MuiBadge-badge": {
      minWidth: 0,
      width: 16,
      height: 16,
      fontSize: 9,
      p: 0,
      lineHeight: "18px",
      top: 5,
      right: 5,
    },
  },
}
